import { formatLanguage } from "./siteUtils";

export const MathUtils = {
  map(num, min1, max1, min2, max2, round = false, constrainMin = true, constrainMax = true) {
    if (constrainMin && num < min1) {
      return min2;
    }
    if (constrainMax && num > max1) {
      return max2;
    }

    const num1 = (num - min1) / (max1 - min1);
    const num2 = num1 * (max2 - min2) + min2;
    if (round) {
      return Math.floor(num2);
    }
    return num2;
  },

  clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  },

  randomRange(min, max) {
    return Math.random() * (max - min) + min;
  },

  mod(n, x) {
    return ((n % x) + x) % x;
  },

  byteSize(bites, length = 4, units = ["b", "Kb", "Mb", "Gb", "Tb", "Pb"]) {
    // converts value to next upper unit (example: Kb -> Mb)
    function divide(value) {
      return value / 1000;
    }

    // gets length of number, to help decide if we want to convert to next upper unit
    function getLength(value) {
      return String(Math.round(value)).length;
    }

    // rounds number to 1 decimal place
    function round(value) {
      return Math.round(value * 10) / 10;
    }

    let value = bites;
    let index = 0;

    // loops until the unit has less than 4 digits.
    while (getLength(value) >= length) {
      value = divide(value);
      index += 1;
    }

    value = round(value);

    return {
      bites,
      value,
      index,
      units,
      toString: () => {
        return `${value}${units[index]}`;
      }
    };
  },

  numbersFormat(value) {
    let stringValue = String(value);
    if (stringValue.length >= 4 && value <= 9999) {
      stringValue = stringValue.split("");
      stringValue.splice(1, 0, ",");
      stringValue = stringValue.join("");
    }
    return value > 9999 ? String(`${(value / 1000).toFixed(1)}k`) : stringValue;
  },
  numbersPrice(value, dotlength) {
    let dotDefault = dotlength > -1 ? dotlength : 2, //默认小数点后两位
      valueStr = String(value),
      priceArr = valueStr.split("."),
      intNum = priceArr[0],
      dot = priceArr.length === 2 ? priceArr[1] : "00",
      dotPre = dotDefault > 0 ? "." : "",
      resPrice = value;
    if (value > 999) {
      intNum = parseFloat(intNum); // 转成数字
      intNum = intNum.toLocaleString(); // 转成金额显示模式
    }
    if (dot.length >= dotDefault) {
      dot = dot.slice(0, dotDefault);
    } else {
      let zeronum = "";
      for (let i = 0; i < dotDefault - dot.length; i++) {
        zeronum += "0";
      }
      dot += zeronum;
    }
    dot = dotPre + dot;
    resPrice = intNum + dot;
    return resPrice;
  },
  priceFormat(value, lang, currency) {
    const language = formatLanguage(lang);
    let val = new Intl.NumberFormat(language, {
      style: "currency",
      currency: currency || "EUR"
    }).format(value);
    let newArr = val.split(" ");
    let newVal = val;
    switch (language) {
      case "sv-SE":
        return new Intl.NumberFormat(language, {
          style: "currency",
          currency: currency || "SEK"
        }).format(value);
      case "nl-BE":
        newVal = newArr.length > 1 ? `${newArr[1]} ${newArr[0]}` : newVal;
        return newVal;
      case "fr-BE":
        newVal = MathUtils.priceFormat(value, "nl-be", currency);
        return newVal;
      case "it-IT":
        newVal = newArr.length > 1 ? `${newArr[1]} ${newArr[0]}` : newVal;
        return newVal;
      case "es-ES":
        newVal = MathUtils.priceFormat(value, "de-DE", currency);
        return newVal;
      default:
        return newVal;
    }
  },
  priceFormatSpecial(value, lang, bl) {
    if (bl && lang.toLowerCase() === "sv-se") {
      value = Math.round(value);
    }
    let formatPrice = MathUtils.priceFormat(value, lang);
    if (bl && lang.toLowerCase() === "sv-se") {
      formatPrice = formatPrice.replace(",00", "");
    }
    return formatPrice;
  },
  percentFormat(value, lang, minimumFractionDigits = 2, maximumFractionDigits = 2) {
    const language = formatLanguage(lang);
    return new Intl.NumberFormat(language, {
      style: "percent",
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits
    }).format(value / 100);
  },
  padding(num, length){
    const str = num.toString();
    return (Math.pow(10, length) + num).toString().substr(str.length > length ? 0 : 1);
  }
};
